import { OpaqueToken } from "@angular/core";
import { environment } from 'environments/environment';

export let ASSETS_CONFIG = new OpaqueToken("assets.config");
 
export class IAssetsConfig {
    assy: Array<string>; // // lektorzy 
}

export const AssetsConfig: IAssetsConfig = {       
    
    // lektorzy 
    assy :  [
        '/assets/assy/Saint_1_small.gif', 
        '/assets/assy/Saint_2_small.gif'
    ]   

};



// WEBPACK FOOTER //
// ./src/app/assets.config.ts